import { RouteRecordRaw } from 'vue-router';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { VIEW_MODE } from '@/common/define/common.define';

const PREFIX_GPU = 'gpu_';

const gpuMenu: RouteRecordRaw[] = [
  {
    path: '/gpu/',
    name: `${PREFIX_GPU}Gpu`,
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    redirect: '/gpu/resource',
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_GPU_MONITORING,
      invisibleViewMode: [VIEW_MODE.MAXGAUGE, VIEW_MODE.INTERMAX],
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'resource',
        name: `${PREFIX_GPU}GPU Resource`,
        component: () => import('@/gpu/views/gpuResourceView/GpuResourceView.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_GPU_RESOURCE,
        },
      },
      {
        path: 'workload',
        name: `${PREFIX_GPU}GPU Workload`,
        component: () => import('@/gpu/views/gpuWorkloadView/GpuWorkloadView.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_GPU_WORKLOAD,
        },
      },
      {
        path: 'monitoring',
        name: `${PREFIX_GPU}GPU Monitoring`,
        component: () => import('@/gpu/views/gpuMonitoringView/GpuMonitoringView.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_GPU,
        },
      },
    ],
  },
];

const getGpuNaviMenu = () => [...extractAccessibleRoutes(gpuMenu)];

export { gpuMenu, getGpuNaviMenu };
